module.exports = Backbone.Model.extend({
    defaults: {
    	name: '',
    	code: '',
    	currency: '',
    	image: ''
	}
});